import { connect } from 'react-redux';

import { getExternalMeeting } from 'actions/ZoomActions';
import { createZoomEvent, updateZoomEvent } from 'actions/EventActions';
import ExistingZoomLinkForm from './ExistingZoomLinkForm';

import { formatVirtualEventStart } from '../../../../util/formDataUtil';

const mapDispatch = (dispatch, ownProps) => ({
  onValidateLink: link => dispatch(getExternalMeeting(link)),
  onSubmit: formValues => {
    const { type, timezone, date, startTime, name, zoomMeetingId } = formValues;
    const formattedStartTime = formatVirtualEventStart({ date, time: startTime });
    const request = {
      virtual: true,
      type,
      start_at: formattedStartTime,
      timezone,
      name,
      meeting_id: zoomMeetingId,
    };
    if (ownProps.isUpdate) {
      const { eventId } = formValues;
      request.id = eventId;
      return dispatch(updateZoomEvent(request)).then(() => {
        if (typeof ownProps.onUpdateSuccess === 'function') {
          ownProps.onUpdateSuccess();
        }
      });
    }
    return dispatch(createZoomEvent(request)).then(() => {
      if (typeof ownProps.onCreateSuccess === 'function') {
        ownProps.onCreateSuccess();
      }
    });
  },
});

export default connect(null, mapDispatch)(ExistingZoomLinkForm);



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ExistingZoomLinkForm/index.js